// pages/HomePage.jsx
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Box, Heading, Text } from '@chakra-ui/react'
import HomeSection1 from './sections/home1'
import HomeSection2 from './sections/home2'
import HomeSection3 from './sections/home3'

function HomePage() {
    const location = useLocation()

    useEffect(() => {
        const params = new URLSearchParams(location.search)
        const section = params.get('section')

        if (section === 'home') {
            window.scrollTo({ top: 0, behavior: 'smooth' })
        } else if (section) {
            const el = document.getElementById(section)
            if (el) el.scrollIntoView({ behavior: 'smooth' })
        }
    }, [location.search])

    return (
        <>
            <Box>
                <HomeSection1/>
                <HomeSection2/>
                <HomeSection3/>
            </Box>
        </>
    )
}

export default HomePage
